import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {CardModule} from '../../../../../../../core/component/card/card.module';
import {
    AccountingMovementCreateFormModule
} from '../../../../../../../accounting/movement/api/component/accounting-movement-create-form/accounting-movement-create-form.module';
import {
    ViewByIdDefaultPagePageModule
} from '../../../../../../../core/page/view-by-id-default-page/view-by-id-default-page.module';
import {ErrorCardModule} from '../../../../../../../../components/common/error-card/error-card.module';
import {PriceLabelModule} from '../../../../../../../common/price/api/component/price-label/price-label.module';
import {ButtonModule} from '../../../../../../../core/component/button/button.module';
import {LoadingModule} from '../../../../../../../../components/common/loading/loading.module';
import {PaymentRequestMovementCreateDialogComponent} from './payment-request-movement-create-dialog.component';
import {DialogModule} from '../../../../../../../common/dialog/dialog.module';
import {ViewByIdDefaultModule} from "../../../../../../../core/component/view-by-id-default/view-by-id-default.module";
import {ActionButtonModule} from "../../../../../../../core/component/action-button/action-button.module";
import {
    ServiceContainerComponent
} from "../../../../../../../core/component/service-container/service-container.component";
import {CardV2Component} from "../../../../../../../core/component/card-v2/card-v2.component";
import {FormFieldModule} from "../../../../../../../core/component/form-field/form-field.module";
import {
    SelectFilterV2Component
} from "../../../../../../../../components/common/select-filter-v2/select-filter-v2.component";
import {
    MultipleSelectFilterModule
} from "../../../../../../../core/component/multiple-select-filter/multiple-select-filter.module";
import {
    MultipleSelectFilterSimpleModule
} from "../../../../../../../core/component/multiple-select-filter-simple/multiple-select-filter-simple.module";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        CardModule,
        AccountingMovementCreateFormModule,
        ViewByIdDefaultPagePageModule,
        ErrorCardModule,
        PriceLabelModule,
        ButtonModule,
        LoadingModule,
        DialogModule,
        ViewByIdDefaultModule,
        ActionButtonModule,
        ServiceContainerComponent,
        CardV2Component,
        FormFieldModule,
        SelectFilterV2Component,
        MultipleSelectFilterModule,
        MultipleSelectFilterSimpleModule,
    ],
    declarations: [PaymentRequestMovementCreateDialogComponent]
})
export class PaymentRequestMovementCreateDialogModule {
}
